import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  margin-top: 0.8rem;
  padding: ${({ theme }) => theme.spaces.xl}rem ${({ theme }) => theme.spaces.xxl}rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    padding: 0;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 6.1rem;
  gap: 1rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    margin-top: ${({ theme }) => theme.spaces.s}rem;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    margin-top: ${({ theme }) => theme.spaces.l}rem;
  }
`;

// Higiene 2026-07-07 (Task 1 refactor): consolidados desde duplicados
// byte-idénticos en NewSurveillanceRouteOrder/index.tsx y
// NewSurveillanceRouteOrder/Summary/index.tsx (card de contenido con fondo
// lila). Otros "Container" del módulo (MultimediaPage, RouteChildOrders,
// ChildOrdersPage) difieren en CSS real y quedan locales a su carpeta — ver
// styles.ts de cada uno.
export const ContentContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundLila};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  padding: ${({ theme }) => theme.spacing.xxl};

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    padding: ${({ theme }) => theme.spacing.xl};
  }
`;

// Higiene 2026-07-07: variante más completa de "mensaje gris" hallada en el
// módulo (RouteDetailed/MultimediaPage/index.tsx). Otras variantes
// (RouteChildOrders, ChildOrdersPage/EmptyState) difieren en CSS real
// (distinto elemento HTML y/o propiedades) y quedan locales — ver styles.ts.
export const InfoMessage = styled.p`
  color: ${({ theme }) => theme.colors.greyDark};
  font-size: ${({ theme }) => theme.fontSize.M};
  text-align: center;
  padding: ${({ theme }) => theme.spacing.xxl};
  margin: 0;
`;

// Higiene 2026-07-07 (Task 3 del refactor de patrones RV, review de Task 2):
// consolidados desde duplicados byte-idénticos en
// `OperarisTabContent/styles.ts` y `UbicacioTab/styles.ts` (layout 2 columnas
// form/mapa, colapsa a columna en landscapeTablet). El par homónimo de
// `RouteDetailed/styles.ts` difiere en CSS real (height:100%, overflow-y:auto,
// gaps distintos) y queda local a esa carpeta.
export const ContentArea = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xl};

  /* Fix 2026-07-04 (feedback usuario): el mapa CAE debajo del form ya en
      landscapeTablet — con menos ancho se aplastaba a un hilo. */
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.m};
  }
`;

export const MainContent = styled.div`
  flex: 1;
  /* 50/50 canónico (LocationForm.MainContainer usa flex:1 1 0 + min-width:0
      en ambos hijos): sin esto el form empuja al mapa en anchos medios. */
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.l};
`;
